const callLogfilterSortReducer = (
    state = {},
    action: {
      type: "SET_CALLLOG_FILTER_SORT";
      payload: any;
    }
  ) => {
    switch (action.type) {
      case "SET_CALLLOG_FILTER_SORT":
        return { ...action.payload };
  
      default:
        return state;
    }
  };
  
  export default callLogfilterSortReducer;